module.exports = __webpack_public_path__ + "static/media/DIRAD.ef399365.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/DIRAD.png
// module id = 445
// module chunks = 0